module.exports = __webpack_public_path__ + "img/ios.2928664f.svg";